export default __webpack_public_path__ + "static/media/bnbrewardssectionimage.bddfcd2b.png";